import React from 'react';
import PropTypes from 'prop-types';

import Row from '../row/row';

import './row-two-col-old.less';

/**
 * Two column row. If passed a single child, uses this as the left column.
 * If passed an array of children, uses the first element as left, and the second as right.
 * If passed more than two children in the array, element 3+ are ignored.
 */
const RowTwoColOld = ({ children, wrapReverse, ...props }) => {
  let firstChild = null;
  let secondChild = null;

  if (Array.isArray(children)) {
    // eslint-disable-next-line prefer-destructuring
    firstChild = children[0];
    secondChild = (children.length > 1 && children[1]) || null;
  } else {
    firstChild = children;
  }

  const rowChild = (
    <div
      className={`row-two-col-old-container${
        wrapReverse ? ' wrap-reverse' : ''
      }`}
    >
      <div>{firstChild}</div>
      <div>{secondChild}</div>
    </div>
  );

  const rowProps = {
    ...props,
    children: rowChild,
  };

  return <Row {...rowProps} />;
};

RowTwoColOld.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.array]),
  wrapReverse: PropTypes.bool,
};

RowTwoColOld.defaultProps = {
  children: null,
  wrapReverse: false,
};

RowTwoColOld.displayName = 'RowTwoColOld';

export default RowTwoColOld;
